import {
  useTheme,
  Grid2 as Grid,
  Typography,
  Box,
  IconButton,
} from '@mui/material'
import { useState } from 'react'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import ProfileSelectionCard from '../../../components/ProfileSelectionCard'
import VitalsCard from '../../../components/VitalsCard'
import Colors from '../../../utils/colors.json'
import { ReactComponent as WizardBadgeIcon } from '../../../assets/icons/WizardBadge.svg'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'

const styles = (theme: any) => ({
  sectionHeading: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#454545s',
  },
  fieldLabel: {
    fontSize: theme.typography.pxToRem(13),
    color: Colors.TEXT_COLOR_TERTIARY,
    fontWeight: 400,
  },
  fieldValue: {
    fontWeight: 400,
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(14),
  },
  status: {
    color: 'green',
  },
  scoreSection: {
    background: theme.palette.primary.light,
    borderRadius: '20px',
    // width: 'fit-content',
  },
  docsBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '10px',
  },
})

const PhysicalTests = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  // eslint-disable-next-line
  const [candidates, setCandidates] = useState([
    {
      name: 'Vinod Gadde',
      role: 'Father',
      age: 29,
      avatarSrc: 'https://i.pravatar.cc/150?img=3',
      selected: false,
    },
    {
      name: 'Sunitha Reddy',
      role: 'Mother',
      age: 27,
      avatarSrc: 'https://i.pravatar.cc/150?img=4',
      selected: false,
    },
    {
      name: 'Rohit Gadde',
      role: 'Son',
      age: 7,
      avatarSrc: 'https://i.pravatar.cc/150?img=5',
      selected: false,
    },
  ])
  const [selectedCandidate, setSelectedCandidate] = useState(
    candidates?.[0]?.name
  )
  // eslint-disable-next-line
  const [physicalAssesment, setPhysicalAssesment] = useState([
    {
      name: 'Height',
      value: '182',
      unit: 'cm',
      note: '-',
    },
    {
      name: 'Weight',
      value: '90',
      unit: 'kg',
      note: '-',
    },
    {
      name: 'BMI',
      value: '30',
      unit: '',
      note: 'obesity',
    },
  ])
  // eslint-disable-next-line
  const [vitalSigns, setVitalSigns] = useState([
    {
      name: 'Blood Pressure',
      value: '140/100',
      unit: 'mmHg',
      note: 'Hypertension',
    },
    {
      name: 'Respiration Rate',
      value: '20',
      unit: 'breaths/min',
      note: 'Normal',
    },
    {
      name: 'Oxygen Saturation',
      value: '100',
      unit: '%',
      note: 'Very Healthy',
    },
    {
      name: 'Heart Rate(Pulse)',
      value: '80',
      unit: 'Bpm',
      note: 'Normal',
    },
    {
      name: 'Temperature',
      value: '101',
      unit: 'F',
      note: 'Higher Than Normal',
    },
  ])
  // eslint-disable-next-line
  const [others, setOthers] = useState([
    {
      name: 'Vision Test',
      value: '18/18',
      unit: '',
      note: 'Cataract In The Right Eye',
    },
    {
      name: 'Hearing Test',
      value: 'Normal',
      unit: '',
      note: '-',
    },
    {
      name: 'Abdominal Examination',
      value: 'Normal',
      unit: '',
      note: '-',
    },
    {
      name: 'Skin Examination',
      value: 'Normal',
      unit: '',
      note: '-',
    },
  ])

  return (
    <Grid
      container
      height={'100%'}
      width={'100%'}
      direction={'column'}
      spacing={2}
    >
      <Grid
        container
        spacing={1}
        direction={'row'}
        position={'sticky'}
        top={0}
        zIndex={1}
        size={{ xs: 6, lg: 8, xl: 8, sm: 12 }}
      >
        <Grid size={{ xs: 8, sm: 6, xl: 4 }}>
          <Typography className={classes?.fieldLabel}>
            Home Visit{' '}
            <span className={classes?.fieldValue}>
              (16/2/24 @ 11:00 AM){' '}
              <span className={classes?.status}>Completed</span>
            </span>
          </Typography>
          <Typography className={classes?.fieldLabel}>
            Physical Assessment:{' '}
            <span className={classes?.fieldValue}>IN-AS-9-3-XXXXX</span>
          </Typography>
        </Grid>
        <Grid size={{ xs: 4, sm: 6, xl: 3 }}>
          <Box
            display={'flex'}
            justifyContent={'start'}
            alignItems={'center'}
            className={classes?.scoreSection}
          >
            <WizardBadgeIcon />
            <Box component={'span'}>
              Health Score : <Box component={'span'}>70/100</Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        direction={'row'}
        position={'sticky'}
        top={0}
        zIndex={1}
        size={{ xs: 12 }}
      >
        {candidates?.map((item, index) => {
          return (
            <Grid size='auto' key={index}>
              <ProfileSelectionCard
                name={item?.name}
                role={item?.role}
                age={item?.age}
                avatarSrc={item?.avatarSrc}
                selected={selectedCandidate === item?.name}
                onClick={() => {
                  setSelectedCandidate(item?.name)
                }}
                section={
                  selectedCandidate === item?.name ? (
                    <Box className={classes?.docsBtn} ml={2}>
                      <IconButton color='inherit' size='small'>
                        <CloudDownloadIcon />
                      </IconButton>
                      Docs
                    </Box>
                  ) : null
                }
              />
            </Grid>
          )
        })}
      </Grid>
      <Box
        display={'flex'}
        flexDirection={'column'}
        gap={3}
        sx={{ flex: 1, overflowY: 'auto' }}
        pr={2}
      >
        <Grid container spacing={1} direction={'column'}>
          <Typography className={classes?.sectionHeading}>
            Physical Assesment
          </Typography>
          <Grid container spacing={1} direction={'row'}>
            {physicalAssesment?.map((item, index) => {
              return (
                <Grid
                  size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }}
                  key={index}
                >
                  <VitalsCard
                    name={item?.name}
                    value={item?.value}
                    unit={item?.unit}
                    note={item?.note}
                  />
                </Grid>
              )
            })}
          </Grid>
        </Grid>
        <Grid container spacing={1} direction={'column'}>
          <Typography className={classes?.sectionHeading}>
            Vital Signs
          </Typography>
          <Grid container spacing={1} direction={'row'}>
            {vitalSigns?.map((item, index) => {
              return (
                <Grid
                  size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }}
                  key={index}
                >
                  <VitalsCard
                    name={item?.name}
                    value={item?.value}
                    unit={item?.unit}
                    note={item?.note}
                  />
                </Grid>
              )
            })}
          </Grid>
        </Grid>
        <Grid container spacing={1} direction={'column'}>
          <Typography className={classes?.sectionHeading}>Others</Typography>
          <Grid container spacing={1} direction={'row'}>
            {others?.map((item, index) => {
              return (
                <Grid
                  size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }}
                  key={index}
                >
                  <VitalsCard
                    name={item?.name}
                    value={item?.value}
                    unit={item?.unit}
                    note={item?.note}
                  />
                </Grid>
              )
            })}
          </Grid>
        </Grid>
        <Grid container spacing={1} direction={'column'}></Grid>
        <Grid container spacing={1} direction={'column'}></Grid>
        <Grid container spacing={1} direction={'column'}></Grid>
        <Grid container spacing={1} direction={'column'}></Grid>
        <Grid container spacing={1} direction={'column'}></Grid>
      </Box>
    </Grid>
  )
}

export default PhysicalTests
